(function() {
    var togglers = document.querySelectorAll('[data-toggler]');
    var targets = document.querySelectorAll('[data-toggler-target]');
    var activeToggler = null;
    var activeTarget = null;

    // fermeture du méga-menu si click à l'extérieur du panneau méga-menu
    document.addEventListener('click', function(e) {
        if(activeTarget && activeTarget.hasAttribute('data-mega-menu')) {
            if (!activeTarget.contains(e.target) && !activeToggler.contains(e.target)) {
                activeTarget.classList.remove('is-active');
                activeTarget = null;
                if(activeToggler) {
                    activeToggler.classList.remove('is-active');
                    activeToggler = null;
                }
            }
        }
    });

    // gestion des togglers

    [].forEach.call(togglers, function (item) {
        Toggler(item);
    });

    function Toggler(element) {

        if(!element.dataset.toggler) {
            return;
        }

        var target = document.querySelector('[data-toggler-target=' + element.dataset.toggler + ']');
        element.addEventListener('click', toggle);

        function toggle(event) {
            event.preventDefault();
            // fermer les autres togglers qui sont ouverts (sauf si le toggler est à l'intérieur d'un toggler ouvert et si ce n'est pas un filtre)
            for(var i = 0; i < togglers.length; i++) {
                if(togglers[i] !== this
                    && !togglers[i].hasAttribute('data-toggler-filters')
                    && !targets[i].contains(this) 
                    && togglers[i].classList.contains('is-active')) {
                    togglers[i].classList.remove('is-active');
                    if(targets[i].classList.contains('is-active')) {
                        targets[i].classList.remove('is-active');
                    }
                }
            }

            this.classList.toggle('is-active');
            activeToggler = this;

            if(target) {
                target.classList.toggle('is-active');
                activeTarget = target;
    
                if (target.classList.contains('is-hidden')) {
                    target.classList.remove('is-hidden');
                }
            }
        }
    }
}());
